import 'firebase/messaging';

import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'AIzaSyDhefCjgOahfEKPnsSxBK-XkZ3VWb0sRHI',
  authDomain: 'almeida-junior.firebaseapp.com',
  projectId: 'almeida-junior',
  storageBucket: 'almeida-junior.appspot.com',
  messagingSenderId: '1032735374585',
  appId: '1:1032735374585:web:f6666533622a37baad3628'
};

export default firebase.initializeApp(firebaseConfig);

let msg = null;

if (firebase.messaging.isSupported()) {
  msg = firebase.messaging();

  msg.getToken({
    vapidKey: 'BOMlw6KSKnFLPPQtx2a1qZTJ585EwL1OZVENXjlk_tJqQ2ANS3RweF0aRH3FtO-QBQjijLR6kIO6gcK4jE9KY6Y'
  }).then((currentToken) => {
    if (currentToken) {
      localStorage.setItem('notificationToken', currentToken);
    } else {
      console.log('No registration token available. Request permission to generate one.');
    }
  }).catch((err) => {
    console.error('An error occurred while retrieving token. ', err);
  });

  msg.onMessage((payload) => {
    console.log('Message received. ', payload);
  });
}

export const messaging = msg;
